import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdBusiness } from 'react-icons/md';

const Company: React.FC<IconBaseProps> = (props) => <MdBusiness {...props} />;

export default Company;
